<template lang="pug">
.gradient-decor(:class="getClass", :style="setCssVariables")
</template>
<script>
export default {
  name: "GradientDecor",
  props: {
    colorBg: {
      type: String,
      default: "",
    },
    colorDecor: {
      type: String,
      default: "000",
    },
    direction: {
      type: String,
      default: "to-left", // to-left, to-right
    },
    isFlipped: {
      type: Boolean,
      default: false,
    },
    isNoTail: {
      type: Boolean,
      default: false,
    },
    isBorder: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getClass() {
      return [
        `gradient-decor--${this.direction}`,
        { "gradient-decor--flipped": this.isFlipped },
        { "gradient-decor--no-tail": this.isNoTail },
        { "gradient-decor--border": this.isBorder },
      ];
    },

    setCssVariables() {
      let color_bg = this.colorBg ? `#${this.colorBg}` : "transparent";
      let color_decor = this.colorDecor ? `#${this.colorDecor}` : "transparent";
      return `
          --decor-bg-color: ${color_bg};
          --decor-color: ${color_decor};
        `;
    },
  },
};
</script>
  <style lang="scss" scoped>
  @import "../style/gradient-decor";
  </style>
